import * as React from 'react'
import {ReactNode} from 'react'
import {APPLY_CATEGORY, ROLE_FOR_GUEST} from '../../../../../CodeMaster'
import {convertToRoomNumberForResident} from '../../../../common/util/Natutil'
import NatGuestOwnershipTransfersDetailConfirmItem from '../../common/NatGuestOwnershipTransfersDetailConfirmItem'
import {BlockSpacer} from '../../../../../styledComponents/ResponsiveConvenience'
import {
    getFormattedAddress
} from '../../../applications/contactAddressOnEmergencies/helper/NatContactAddressOnEmergencyHelper'
import {formatDate} from '../../../../../formatters/formatDate'
import styled from 'styled-components'
import {StyledDiv} from '../../../../../styledComponents/StyledTypeDefinitions'
import moment from 'moment'
import {
    GuestLoginInfoSessionStorageKey,
    NatGuestLoginInfoSessionStorageHelper
} from '../../../../common/authentication/NatGuestLoginInfoSessionStorageHelper'


interface Props {
    applyId?: string
    isApply?: boolean
    ownershipTransferDate: string
    accessExpirationDate?: string
    companyName: string
    zipCode: string
    prefecture: string
    address2: string
    address3: string
    buildingRoomNumber: string
    representative: string
    phoneNumber: string
    mailAddress: string
}

const NatGuestIntermediaryConfirm = ({applyId, ...otherProps}: Props) => {
    const {
        ownershipTransferDate, accessExpirationDate, companyName, zipCode,
        prefecture, address2, address3, buildingRoomNumber,
        representative, phoneNumber, mailAddress, isApply
    } = otherProps

    const ownershipTransferDateLabel = formatDate(ownershipTransferDate);
    const accessExpirationDateLabel = accessExpirationDate ? formatDate(accessExpirationDate) : null;
    const applyCategoryLabel = APPLY_CATEGORY.OWNERSHIP_TRANSFER.label + '（' + ROLE_FOR_GUEST.INTERMEDIARY.label + '様向け）'
    const applicantRoom = NatGuestLoginInfoSessionStorageHelper
            .getStringItemOrNull(GuestLoginInfoSessionStorageKey.SELECTED_CONDOMINIUM_NAME) + '　' +
        NatGuestLoginInfoSessionStorageHelper
            .getStringItemOrNull(GuestLoginInfoSessionStorageKey.SELECTED_RIDGE_NAME) + ' ' +
        convertToRoomNumberForResident(
            NatGuestLoginInfoSessionStorageHelper
                .getStringItemOrNull(GuestLoginInfoSessionStorageKey.SELECTED_ROOM_NUMBER)
        )

    const paymentChangeDeadLineInfo = (): ReactNode => {
        const momentOwnershipTransferDate = moment(ownershipTransferDate)
        const oldMemberDate = momentOwnershipTransferDate.clone().add(1, 'months') // 翌月
        const newMemberDate = momentOwnershipTransferDate.clone().add(2, 'months') // 翌々月

        const items = []
        items.push(`旧組合員：${oldMemberDate.year()}年${oldMemberDate.month() + 1}月分まで支払い`)
        items.push(`新組合員：${newMemberDate.year()}年${newMemberDate.month() + 1}月分から支払い`)

        return <>
            <NatGuestOwnershipTransfersDetailConfirmItem
                title={'管理費等の支払変更期日'}
                items={items}
            />
        </>
    }

    const intermediaryInfo = (): ReactNode => {
        const items = []

        items.push(`企業名：${companyName}`)
        items.push(`住所：${getFormattedAddress(
            zipCode,
            prefecture,
            address2,
            address3,
            buildingRoomNumber)}`)
        items.push(`担当者：${representative}`)
        items.push(`電話番号：${phoneNumber}`)

        if (mailAddress) {
            items.push(`メールアドレス：${mailAddress}`)
        }

        return <>
            <NatGuestOwnershipTransfersDetailConfirmItem
                title={'仲介業者情報'}
                items={items}
            />
        </>
    }

    return (<>
        {applyId && !isApply &&
            <>
                <ViewExpirationDateDiv>閲覧期限：{[accessExpirationDateLabel]}</ViewExpirationDateDiv>
                <NatGuestOwnershipTransfersDetailConfirmItem
                    title={'申請ID'}
                    items={[applyId]}
                />
                <BlockSpacer height={'5px'}/>
            </>
        }
        <NatGuestOwnershipTransfersDetailConfirmItem
            title={'申請区分'}
            items={[applyCategoryLabel]}
        />
        <BlockSpacer height={'5px'}/>
        <NatGuestOwnershipTransfersDetailConfirmItem
            title={'対象住戸'}
            items={[`${applicantRoom}`]}
        />
        <BlockSpacer height={'5px'}/>
        <NatGuestOwnershipTransfersDetailConfirmItem
            title={'組合員変更年月日'}
            items={[`${ownershipTransferDateLabel}`]}
        />
        <BlockSpacer height={'5px'}/>
        {paymentChangeDeadLineInfo()}
        <BlockSpacer height={'5px'}/>
        {intermediaryInfo()}
    </>)
}

NatGuestIntermediaryConfirm.displayName = 'NatGuestIntermediaryConfirm'
export default NatGuestIntermediaryConfirm

const ViewExpirationDateDiv: StyledDiv = styled.div`
  display: block;
  text-align: right;
  margin-bottom: 5px;
`